module.exports = __webpack_public_path__ + "img/icon_2.6fe1c5d7.png";